import { MODAL_STYLES } from "../../constants/modal-styles";
import { ModalButton } from "./ModalButton";

interface RulesModalProps {
  isOpen: boolean;
  language: "ka" | "en";
  onLanguageChange: (lang: "ka" | "en") => void;
  onClose: () => void;
}

export const RulesModal = ({
  isOpen,
  language,
  onLanguageChange,
  onClose,
}: RulesModalProps) => {
  if (!isOpen) return null;

  const content = {
    ka: {
      title: "თამაშის შესახებ",
      description: "გაიცანით, შეადგინეთ შეტყობინებები და მოიპოვეთ საჩუქრები!",
      rules: [
        "შეიყვანეთ კოდი და აირჩიეთ მოქმედება",
        "დააწკაპუნეთ ღრუბელზე შინაარსის გასახსნელად",
        "თითოეული კოდით შეგიძლიათ გახსნათ მხოლოდ 1 უჯრედი",
        "იპოვეთ შეტყობინებები, გაიცანით ადამიანები ან მოიპოვეთ პრიზები",
        "თუ ღრუბელი ცარიელია, გამოჩნდება კომპასი უახლოეს სუნდუკამდე",
        "ასევე შეგიძლიათ დატოვოთ საკუთარი შეტყობინება ან გაცნობა",
      ],
      close: "დახურვა",
    },
    en: {
      title: "About the Game",
      description: "Meet people, leave messages and win prizes!",
      rules: [
        "Enter code and choose action",
        "Click on a cloud to reveal content",
        "Each code can open only 1 cell",
        "Find messages, meet people or get prizes",
        "If cloud is empty, compass appears to nearest chest",
        "You can also leave your own message or acquaintance",
      ],
      close: "Close",
    },
  };

  const text = content[language] || content.ka;

  return (
    <div className={MODAL_STYLES.overlay} onClick={onClose}>
      <div
        className="relative w-full max-w-md bg-amber-100 rounded-xl border-2 border-amber-800 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        style={{
          fontFamily: MODAL_STYLES.fontFamily,
        }}
      >
        <div className={MODAL_STYLES.content}>
          <h2 className="text-base sm:text-lg font-bold text-amber-900 mb-3 text-center">{text.title}</h2>

          <p className="text-xs sm:text-sm text-amber-800 text-center mb-4 italic">
            {text.description}
          </p>

          <div className="space-y-2 mb-4">
            {text.rules.map((rule, index) => (
              <div key={index} className="flex items-start gap-2">
                <span className="text-amber-700 font-bold text-sm flex-shrink-0">{index + 1}.</span>
                <p className="text-xs sm:text-sm">{rule}</p>
              </div>
            ))}
          </div>

          <ModalButton onClick={onClose}>
            <span className="text-xs sm:text-sm">{text.close}</span>
          </ModalButton>
        </div>
      </div>
    </div>
  );
};
